const getBusinessNPI = ({ business, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (business && business['Company Identify'] && business['Company Identify'].ID) {
    return business['Company Identify']['Practice NPI'];
  }
  return null;
};

export default getBusinessNPI;



// WEBPACK FOOTER //
// ./src/utils/print/getBusinessNPI.js